import script from "./HappDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HappDetail.vue?vue&type=script&setup=true&lang=js"

import "./HappDetail.vue?vue&type=style&index=0&id=b79fafb6&lang=scss&scoped=true"
script.__scopeId = "data-v-b79fafb6"

export default script